import { doLogGuards } from '@/router';
export const isRouteNameInRoute = (newRouteName, route) => {
    return route.matched.some((matchedRoute) => matchedRoute.name === newRouteName);
};
export const logGuard = (...logs) => {
    if (doLogGuards) {
        // console.log(...logs);
    }
};
